import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";
import DataTable from "react-data-table-component";

const AllAgentTopUpRecord = () => {
  const { agent_id } = useParams();  
  const [transactions, setTransactions] = useState([]);  
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${baseurl}GetWalletTransactionsAgent/${agent_id}`);
        setTransactions(response.data.transactions || []);
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setTransactions([]);
      }
      setLoading(false);
    };

    fetchTransactions();
  }, [agent_id]);

  const columns = [
    { name: "Sr. No.", selector: (row, index) => index + 1, sortable: false, width: "80px" },
    { name: "Amount", selector: (row) => `₹${row.amount}`, sortable: true },
    { name: "Transaction Type", selector: (row) => row.transaction_type, sortable: true },
    { name: "Transaction Detail", selector: (row) => row.transaction_reason, sortable: true, width: "300px" },
    { name: "Date", selector: (row) => new Date(row.created_at).toLocaleDateString(), sortable: true },
  ];

  return (
    <div className=" ">
     

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          data={transactions}
          pagination
          highlightOnHover
          striped
          noDataComponent="No transactions found"
          className="transaction-table"
        />
      )}
    </div>
  );
};

export default AllAgentTopUpRecord;
